import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'
// TODO: Import React components after migration
// import React from 'react'
// import AccessoriesSkus from '../../components/AccessoriesSkus'

// this one is for /accessories pages
export default defineType({
  name: 'modal',
  title: 'Modal',
  type: 'document',
  fields: [
    defineField({
      title: 'Modal Name',
      name: 'name',
      type: 'string',
    }),
    defineField({
      title: 'Link Label',
      name: 'linkLabel',
      type: 'string',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Description',
      name: 'description',
      type: 'array',
      of: strongEmLink,
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'New Configuration' }) {
      return {
        title,
      }
    },
  },
})